import { useMemo } from 'react';
import { useGet } from '../../../../api';
import { USER_MANAGEMENT_BASE_URL } from '../consts';
import type { LocalAccountsBoundAdEntityUser } from '../../types/LocalAccount';

const convertLocalAccountsBoundAdEntityUserDtoToLocalAccountsBoundAdEntityUser = (user: LocalAccountsBoundAdEntityUser): LocalAccountsBoundAdEntityUser => {
    return {
        guid: user.guid,
        displayName: user.displayName,
        userName: user.userName,
        domainName: user.domainName,
        status: user.status,
        excludeTill: user.excludeTill ? new Date(user.excludeTill) : undefined
    };
};

interface Response {
    users: LocalAccountsBoundAdEntityUser[];
}

const useGetLocalAccountsBoundUsers = (adEntityGuid?: string) => {
    const { data, ...restValues } = useGet<Response>({
        url: `${USER_MANAGEMENT_BASE_URL}/localAccounts/${adEntityGuid}/boundUsers`,
        enabled: !!adEntityGuid
    });

    const boundUsers = useMemo(() => {
        if (!data || !data.users) {
            return undefined;
        }

        return data.users.map(convertLocalAccountsBoundAdEntityUserDtoToLocalAccountsBoundAdEntityUser);
    }, [data]);

    return { ...restValues, boundUsers };
};

export default useGetLocalAccountsBoundUsers;